<template>
    <div id="empresa-relatorio-producao">
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina :titulo="lang.empresa" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <div class="col s12 m12 l12">
                                <h4>
                                    Filtros de busca
                                    <i class="material-icons prefix">search</i>
                                </h4>
                            </div>
                            <div class="col s12">
                                <label for="empresaStatus">
                                    Buscar pelo Status
                                </label>
                                <multiselect
                                    v-model="status"
                                    :options="options_status"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    placeholder="Selecione os Status"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false"
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="{ values, search, isOpen }"
                                        ><span
                                            class="multiselect__single"
                                            v-if="values.length && !isOpen"
                                            >{{ values.length }} Status
                                            selecionados</span
                                        ></template
                                    >
                                </multiselect>
                            </div>
                            <div class="input-field col s12 m6 l4">
                                <!--<i class="material-icons prefix">search</i>-->
                                <input
                                    id="nomeEmpresa"
                                    type="text"
                                    v-model="nomeEmpresa"
                                    class="validate"
                                />
                                <label for="nomeEmpresa"
                                    >Buscar pelo nome fantasia</label
                                >
                            </div>
                            <div class="input-field col s12 s3 m6 l4">
                                <!--<i class="material-icons prefix">search</i>-->
                                <input
                                    id="empresa_id"
                                    type="text"
                                    v-model="empresa_id"
                                    class="validate"
                                />
                                <label for="empresa_id"
                                    >Buscar pelo ID da empresa</label
                                >
                            </div>

                            <div class="input-field col s12 m6 l4">
                                <!--<i class="material-icons prefix">search</i>-->
                                <!--<input id="empresaCNPJ" type="text" v-model="empresa_cnpj" class="validate">-->
                                <masked-input
                                    type="text"
                                    id="empresaCNPJ"
                                    v-model="empresa_cnpj"
                                    mask="11111111/1111-11"
                                />
                                <label for="empresaCNPJ"
                                    >Buscar pelo CNPJ</label
                                >
                            </div>
                            <div class="input-field col s12 m6 l6">
                                <!--<i class="material-icons prefix">search</i>-->
                                <input
                                    id="razao_social"
                                    type="text"
                                    v-model="empresa_razao_social"
                                    class="validate"
                                />
                                <label for="razao_social"
                                    >Buscar pela Razão Social</label
                                >
                            </div>
                            <div class="col s12 m6 l6">
                                <!--<i class="material-icons prefix">search</i>-->
                                <!--<input id="estado" type="text" v-model="uf" class="validate">
                <label for="estado">Buscar pelo Estado</label>-->

                                <label for="estado">Buscar pelo Estado</label>
                                <multiselect
                                    v-model="value"
                                    :options="options"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    placeholder="Selecione os Estados"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false"
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="{ values, search, isOpen }"
                                        ><span
                                            class="multiselect__single"
                                            v-if="values.length && !isOpen"
                                            >{{ values.length }} Estados
                                            selecionados</span
                                        ></template
                                    >
                                </multiselect>
                            </div>
                            <div
                                class="col s12 m6 l12"
                                style="margin-bottom: 10px"
                            >
                                <label for="seguradora"
                                    >Selecione as seguradoras</label
                                >
                                <multiselect
                                    v-model="seguradoras"
                                    :options="options_seguradoras"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    placeholder="Selecione as Seguradoras"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false"
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="{ values, search, isOpen }"
                                        ><span
                                            class="multiselect__single"
                                            v-if="values.length && !isOpen"
                                            >{{ values.length }} Seguradoras
                                            selecionadas</span
                                        >
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col s12 m6 l12">
                                <label for="tipo_file"
                                    >Selecione a Condicionante</label
                                >
                                <select
                                    id="tipo_file"
                                    v-model="tipo_busca"
                                    class="browser-default validate"
                                >
                                    <option selected value="and">E</option>
                                    <option value="or">OU</option>
                                </select>
                                <!-- <small><strong>Dica: </strong> A condicionante serve para determinar como as informações serão exibidas no relatório com base nas seguradoras selecionadas:<br>
                <strong>Condicionante E: </strong> Irá trazer as empresas que estão em todas as seguradoras selecionadas.<br>
                <strong>Condicionante OU: </strong> Irá trazer as empresas que estão em uma ou outra seguradora selecionada</small>-->
                            </div>

                            <div class="col s12 m6 l4">
                                <label for="tipo_file"
                                    >Selecione a Seguradora para Buscar por Data
                                    de Efetivação</label
                                >
                                <select
                                    id="tipo_file"
                                    v-model="seguradoraDataEfetivacao"
                                    class="browser-default validate"
                                >
                                    <option
                                        :key="dataSeguradora.value"
                                        :value="dataSeguradora.value"
                                        v-for="dataSeguradora in datasSeguradoras"
                                    >
                                        {{ dataSeguradora.label }}
                                    </option>
                                </select>
                            </div>

                            <div class="col s12 m6 l4">
                                <label for="data_inicio_efetivacao"
                                    >Data Inicio Efetivação</label
                                >
                                <date-picker
                                    id="data_inicio_efetivacao"
                                    v-model="dataInicioEfetivacao"
                                    format="DD/MM/YYYY"
                                    input-class="m-0"
                                    class="width-100"
                                ></date-picker>
                            </div>

                            <div class="col s12 m6 l4">
                                <label for="data_fim_efetivacao"
                                    >Data Fim Efetivação</label
                                >
                                <date-picker
                                    id="data_fim_efetivacao"
                                    v-model="dataFimEfetivacao"
                                    format="DD/MM/YYYY"
                                    input-class="m-0"
                                    class="width-100"
                                ></date-picker>
                            </div>

                            <div class="col s12 m6 l12">
                                <label for="tipo_file"
                                    >Selecione os campos que deseja no
                                    relatório</label
                                >
                                <multiselect
                                    v-model="campos_tabela"
                                    :options="options_campo_tabela"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    placeholder="Selecione os Campos"
                                    :preselect-first="false"
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="{ values, search, isOpen }"
                                        ><span
                                            class="multiselect__single"
                                            v-if="values.length && !isOpen"
                                            >{{ values.length }} Campos
                                            selecionados</span
                                        ></template
                                    >
                                </multiselect>
                            </div>
                            <div class="col s12 m6 l4">
                                <label for="data_inicio"
                                    >Data Inicio Relatório de Produção</label
                                >
                                <date-picker
                                    id="data_inicio"
                                    v-model="data_inicio"
                                    format="DD/MM/YYYY"
                                    input-class="m-0"
                                    class="width-100"
                                ></date-picker>
                            </div>
                            <div class="col s12 m6 l4">
                                <label for="data_fim"
                                    >Data Fim Relatório de Produção</label
                                >
                                <date-picker
                                    id="data_fim"
                                    v-model="data_fim"
                                    format="DD/MM/YYYY"
                                    input-class="m-0"
                                    class="width-100"
                                ></date-picker>
                            </div>
                            <div class="col s12 m6 l4 mt-md-2">
                                <label for="tipo_file">Produtos</label>
                                <multiselect
                                    v-model="produtos"
                                    :options="options_produtos"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    placeholder="Selecione os produtos para o relatório de produção"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false"
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="{ values, search, isOpen }"
                                        ><span
                                            class="multiselect__single"
                                            v-if="values.length && !isOpen"
                                            >{{ values.length }} Produtos
                                            Selecionados</span
                                        ></template
                                    >
                                </multiselect>
                            </div>
                            <div class="col s12 m6 l12 mt-2">
                                <label for="tipo_file"
                                    >Selecione o tipo de Arquivo para
                                    Download</label
                                >
                                <select
                                    id="tipo_file"
                                    v-model="tipo_arquivo"
                                    class="browser-default validate"
                                    style="border: 1px solid #e8e8e8;"
                                >
                                    <option value="pdf" selected>PDF</option>
                                    <option value="xls">Excel (XLS)</option>
                                </select>

                                <div
                                    v-if="isloading"
                                    class="col s12"
                                    style="text-align: center; margin-top: 3rem;"
                                >
                                    <h6>Gerando relatório...</h6>
                                    <pulse-loader
                                        :loading="loading"
                                        :color="blue"
                                        :size="size"
                                    ></pulse-loader>
                                </div>

                                <div
                                    v-if="isloadingCompany"
                                    class="col s12"
                                    style="text-align: center; margin-top: 3rem;"
                                >
                                    <h6>Buscando empresas...</h6>
                                    <pulse-loader
                                        :loading="loading"
                                        :color="blue"
                                        :size="size"
                                    ></pulse-loader>
                                </div>
                            </div>
                            <div class="col s12 m6 l6">
                                <a
                                    class="waves-effect waves-light  mt-4 "
                                    id="btn_show_import"
                                    style="margin-right: 20px; text-align: center;"
                                    @click="importProducao()"
                                    ><i class="material-icons">file_upload</i>
                                    <br />Importar Planilha de Produção</a
                                >
                                <div class="col s12 m4 l6 import">
                                    <label for="tipo_produto"
                                        >Selecione o produto que será
                                        importado</label
                                    >
                                    <select
                                        id="tipo_produto"
                                        v-model="tipo_produto"
                                        class="browser-default validate"
                                    >
                                        <option selected value="vida"
                                            >Vida</option
                                        >
                                        <option value="consorcio"
                                            >Área de Crédito</option
                                        >
                                    </select>
                                    <label for="planilha_produto"
                                        >Escolha o arquivo para Upload</label
                                    >
                                    <input
                                        type="file"
                                        class="browser-default validate"
                                    />
                                    <a
                                        class="waves-effect waves-light btn mt-3 btn-default"
                                        >IMPORTAR</a
                                    >
                                </div>
                                <a
                                    class="waves-effect waves-light  mt-4 "
                                    id="close_import"
                                    style="display: none; margin-right: 20px; text-align: center;"
                                    @click="closeImportProducao()"
                                    ><i class="material-icons">close</i>
                                    <br />Fechar</a
                                >
                            </div>
                            <div class="col s12 m6 l6 botao-busca">
                                <a
                                    class="waves-effect waves-light  mt-4 "
                                    @click="downloadFile()"
                                    style="margin-right: 20px; text-align: center;"
                                    ><i class="material-icons">file_download</i>
                                    <br />Gerar Relatório</a
                                >
                                <a
                                    class="waves-effect waves-light  mt-4"
                                    alt="Gerar Relatório de Produção"
                                    title="Gerar Relatório de Produção"
                                    style="margin-right: 20px; text-align: center;"
                                    @click="gerarRelatorioProd()"
                                    ><i class="material-icons"
                                        >multiline_chart</i
                                    ><br />
                                    Relatório de Produção</a
                                >
                            </div>

                            <!-- Essa tabela é necessária para a altura do card-panel -->
                            <table></table>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
        <div class="fixed-action-btn active" style="bottom: 50px; right: 19px">
            <router-link
                to="/empresa/cadastro"
                id="add-empresa"
                class="btn-floating btn-large btn-default"
            >
                <i class="material-icons">add</i>
            </router-link>
        </div>
    </div>
</template>
<script>
import { PulseLoader } from "vue-spinner/dist/vue-spinner.min.js";
import MaskedInput from "vue-masked-input";
import TituloPagina from "@/components/common/TituloPagina";
import {
    DONO,
    GERENTE,
    CORRETOR,
    ESPECIALISTA,
    MASTER,
    PARCEIRO
} from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";
import getPalavra from "@/helpers/language";
import { api, get } from "@/helpers/api";
import Multiselect from "vue-multiselect";

export default {
    components: {
        TituloPagina,
        MaskedInput,
        Multiselect,
        PulseLoader
    },
    data: () => ({
        tipo_arquivo: "pdf",
        isloading: false,
        isloadingCompany: false,
        childrens: [],
        childrens_of_childrens: [],
        value: [],
        options: [
            { name: "Acre", code: "AC" },
            { name: "Alagoas", code: "AL" },
            { name: "Amapá", code: "AP" },
            { name: "Amazonas", code: "AM" },
            { name: "Bahia", code: "BA" },
            { name: "Distrito Federal", code: "DF" },
            { name: "Espírito Santo", code: "ES" },
            { name: "Goiás", code: "GO" },
            { name: "Maranhão", code: "MA" },
            { name: "Mato Grosso", code: "MT" },
            { name: "Mato Grosso do Sul", code: "MS" },
            { name: "Minas Gerais", code: "MG" },
            { name: "Pará", code: "PA" },
            { name: "Paraíba", code: "PB" },
            { name: "Paraná", code: "PR" },
            { name: "Pernambuco", code: "PE" },
            { name: "Piauí", code: "PI" },
            { name: "Rio de Janeiro", code: "RJ" },
            { name: "Rio Grande do Norte", code: "RN" },
            { name: "Rio Grande do Sul", code: "RS" },
            { name: "Rondônia", code: "RO" },
            { name: "Roraima", code: "RR" },
            { name: "Santa Catarina", code: "SC" },
            { name: "São Paulo", code: "SP" },
            { name: "Sergipe", code: "SE" },
            { name: "Tocantins", code: "TO" }
        ],
        seguradoras: [],
        options_seguradoras: [
            { name: "Advanced", coluna: "advanced" },
            { name: "Bradesco", coluna: "bradesco_seguros" },
            { name: "Caixa Consórcio", coluna: "caixa_newcon" },
            { name: "Centauro On", coluna: "centauro" },
            //{ name: 'Compacta', coluna: ''},
            { name: "Embracon", coluna: "embracon_consorcio" },
            //{ name: 'Espaço Consultor', coluna: ''},
            { name: "Fiduc", coluna: "fiduc_vinculo" },
            { name: "Icatu", coluna: "icatu_vida_horizonte_login" },
            { name: "IHB", coluna: "ihb" },
            { name: "Juspromed", coluna: "juspromed" },
            //{ name: 'Mapfre Bien Vivir', coluna: ''},
            { name: "Mapfre BR Consórcios", coluna: "mapfre_cod" },
            { name: "Mapfre BR Consórcios 2", coluna: "mapfre_cod2" },
            { name: "Mapfre BR Consórcios 3", coluna: "mapfre_cod3" },
            { name: "Mapfre BR Consórcios 4", coluna: "mapfre_cod4" },
            { name: "Mapfre BR Consórcios 5", coluna: "mapfre_cod5" },
            { name: "Metlife", coluna: "metlife" },
            { name: "MAG", coluna: "mongeral_cod" },
            { name: "Omint", coluna: "omint_online" },
            { name: "Porto Seguro", coluna: "porto_cod" },
            { name: "Prudential", coluna: "prudential_cpf" },
            { name: "Remax", coluna: "remax" },
            { name: "Sucursal", coluna: "sucursal" },
            { name: "Sulamérica", coluna: "sulamerica_cod" },
            //{ name: 'Unicarreiras', coluna: ''},
            { name: "Unimed", coluna: "unimed_cod" },
            { name: "Vumi", coluna: "vumi" },
            { name: "Zurich", coluna: "zurich_cod" }
        ],
        campos_tabela: [],
        options_campo_tabela: [],
        produtos: [],
        options_produtos: [
            { name: "Área de Crédito", code: "consorcio" },
            { name: "Vida", code: "vida" },
            { name: "Saúde", code: "saude" },
            { name: "Previdência ", code: "previdencia" }
        ],
        status: [],
        options_status: [
            { name: "Ativo", value: "ativo" },
            { name: "Ativo Field", value: "ativo field" },
            { name: "Ativo Segasp", value: "ativo segasp" },
            {
                name: "Cadastro em Processo - Field",
                value: "cadastro em processo - field"
            },
            {
                name: "Cadastro em Processo - Segasp",
                value: "cadastro em processo - segasp"
            },
            { name: "Inativo", value: "inativo" },
            { name: "Inativo Field", value: "inativo field" },
            { name: "Pendente", value: "pendente" },
            { name: "Plataforma", value: "plataforma" },
            { name: "Saiu Field", value: "saiu field" },
            { name: "Teste", value: "teste" },
            { name: "Verificar", value: "verificar" },
            { name: "Verificar Field", value: "verificar field" },
            { name: 'Em processo de Cadastro', value: 'em processo de cadastro'},
        ],
        lang: {
            empresa: getPalavra("empresa", false, true)
        },

        itens: {},
        nomeEmpresa: null,
        empresa_id: null,
        status_corretor: null,
        empresa_cnpj: null,
        razao_social: null,
        estado: null,
        cargoDono: null,
        cargoGerente: null,
        cargoCorretor: null,
        cargoParceiro: null,
        empresa_selecionada: {
            empresa: null,
            imagens: null
        },

        empresa_razao_social: "",
        tipo_busca: "",
        tipo_produto: "",
        data_inicio: "",
        data_fim: "",

        seguradoraDataEfetivacao: null,
        dataInicioEfetivacao: "",
        dataFimEfetivacao: "",
        datasSeguradoras: [
            {
                label: "Mapfre",
                value: "data_efetivacao_mapfre"
            },
            {
                label: "Icatu",
                value: "data_efetivacao_icatu"
            },
            {
                label: "MAG",
                value: "data_efetivacao_mongeral"
            },
            {
                label: "Zurich",
                value: "data_efetivacao_zurich"
            },
            {
                label: "Unimed",
                value: "data_efetivacao_unimed"
            },
            {
                label: "Prudential",
                value: "data_efetivacao_prudential"
            },
            {
                label: "Metlife",
                value: "data_efetivacao_metlife"
            },
            {
                label: "Vumi",
                value: "data_efetivacao_vumi"
            },
            {
                label: "Porto",
                value: "data_efetivacao_porto"
            },
            {
                label: "Juspromed",
                value: "data_efetivacao_juspromed"
            },
            {
                label: "Wimo",
                value: "data_efetivacao_wimo"
            },
            {
                label: "Caixa",
                value: "data_efetivacao_caixa"
            },
            {
                label: "Embracon Consorcio",
                value: "data_efetivacao_embracon"
            },
            {
                label: "Sulamérica",
                value: "data_efetivacao_sulamerica"
            },
            {
                label: "Unifisa",
                value: "data_efetivacao_unifisa"
            },
            {
                label: "Centauro",
                value: "data_efetivacao_centauro"
            },
            {
                label: "Advanced",
                value: "data_efetivacao_advanced"
            },
            {
                label: "IHB",
                value: "data_efetivacao_ihb"
            },
            {
                label: "Fiduc",
                value: "data_efetivacao_fiduc"
            },
            {
                label: "Omint Online",
                value: "data_efetivacao_omint"
            },
            {
                label: "Bradesco Seguros",
                value: "data_efetivacao_bradesco"
            },
            {
                label: "Sucursal",
                value: "data_efetivacao_sucursal"
            },
            {
                label: "Remax",
                value: "data_efetivacao_remax"
            }
        ]
    }),
    created() {
        // verifica se pode acessar componente
        if (
            Auth.getCargoUsuario() !== MASTER &&
            [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(Auth.getCargoUsuario()) === -1
        ) {
            //      this.$router.push("/sempermissao");
        }
        let self = this;
        this.cargoDono = DONO;
        this.cargoGerente = GERENTE;
        this.cargoCorretor = CORRETOR;

        this.getCamposTabela();
    },
    methods: {
        importProducao() {
            alert(
                "Esta função ainda está em desenvolvimento. Aguarde novas releases."
            );
            $(".import").css("display", "block");
            $("#btn_show_import").css("display", "none");
            $("#close_import").css("display", "block");
        },
        closeImportProducao() {
            $(".import").css("display", "none");
            $("#btn_show_import").css("display", "block");
            $("#btn_show_import").css("float", "left");
            $("#close_import").css("display", "none");
        },
        gerarRelatorioProd() {
            alert(
                "Esta função ainda está em desenvolvimento. Aguarde novas releases."
            );
        },
        downloadFile(file) {
            this.isloading = true;

            if (this.tipo_arquivo == "pdf") {
                //Tratamento do select de estados
                var uf_selecteds = Object.keys(this.value).length;
                /*var estado = [];
                var i = 0;
                if(estado.lenght > 0){
                    for(i = 0; i < uf_selecteds; i++){
                        if (uf_selecteds - 1 == i){
                            estado += [this.value[i].code]
                        }else{
                            estado += [this.value[i].code] + ' ';
                        }

                    }
                    var uf = estado.split(" ");
                }*/
                var uf_selecteds = Object.keys(this.value).length;
                var estado = [];
                var i = 0;
                for (i = 0; i < uf_selecteds; i++) {
                    if (uf_selecteds - 1 == i) {
                        estado += [this.value[i].code];
                    } else {
                        estado += [this.value[i].code] + " ";
                    }

                    var uf = estado.split(" ");
                }

                //tratamento do select de seguradoras
                var selected_seg = Object.keys(this.seguradoras).length;
                var seguradoras = [];
                var i = 0;
                for (i = 0; i < selected_seg; i++) {
                    if (selected_seg - 1 == i) {
                        seguradoras += [this.seguradoras[i].coluna];
                    } else {
                        seguradoras += [this.seguradoras[i].coluna] + "-";
                    }

                    var seg = seguradoras.split("-");
                }

                //Tratamento select status
                var status_selected = Object.keys(this.status).length;
                var status = [];
                var i = 0;
                for (i = 0; i < status_selected; i++) {
                    if (status_selected - 1 == i) {
                        status += [this.status[i].value];
                    } else {
                        status += [this.status[i].value] + ",";
                    }

                    var state = status.split(",");
                }

                //Tratamento select Campos da tabela
                var selected_fields = Object.keys(this.campos_tabela).length;
                var fields = [];
                var i = 0;
                for (i = 0; i < selected_fields; i++) {
                    if (selected_fields - 1 == i) {
                        fields += [this.campos_tabela[i]];
                    } else {
                        fields += [this.campos_tabela[i]] + " ";
                    }

                    var fields_selects = fields.split(" ");
                }

                const specificationId = this.$route.params.specificationId;

                this.axios;
                api.get("empresa/relatorio-cadastradas?", {
                    params: {
                        search: this.nomeEmpresa,
                        empresaID: this.empresa_id,
                        status: state,
                        CNPJ: this.empresa_cnpj,
                        razao_social: this.empresa_razao_social,
                        estado: uf,
                        tipo_arquivo: this.tipo_arquivo,
                        pagination: "0",
                        seguradoras: seg,
                        colunas: fields_selects,
                        tipo_busca: this.tipo_busca,
                        seguradora_data_efetivacao: this
                            .seguradoraDataEfetivacao,
                        data_inicio_efetivacao: this.dataInicioEfetivacao.replaceAll(
                            "/",
                            "-"
                        ),
                        data_fim_efetivacao: this.dataFimEfetivacao.replaceAll(
                            "/",
                            "-"
                        )
                    },
                    headers: this.headers,
                    responseType: "blob" // had to add this one here
                })
                    .then(response => {
                        const content = response.headers["content-type"];
                        require("downloadjs")(
                            response.data,
                            "relatorio",
                            content
                        );
                        //download(response.data, 'relatorio', content)
                        this.isloading = false;
                    })
                    .catch(error => {
                        this.isloading = false;
                        console.log(error);
                        alert("Ocorreu um erro ao efetuar o download: ", error);
                    });
            }
            if (this.tipo_arquivo == "xls") {
                //Tratamento select Campos da tabela
                var selected_fields = Object.keys(this.campos_tabela).length;
                var fields = [];
                var i = 0;
                for (i = 0; i < selected_fields; i++) {
                    if (selected_fields - 1 == i) {
                        fields += [this.campos_tabela[i]];
                    } else {
                        fields += [this.campos_tabela[i]] + " ";
                    }

                    var fields_selects = fields.split(" ");
                }

                //tratamento select estados
                var uf_selecteds = Object.keys(this.value).length;
                var estado = [];
                var i = 0;
                for (i = 0; i < uf_selecteds; i++) {
                    if (uf_selecteds - 1 == i) {
                        estado += [this.value[i].code];
                    } else {
                        estado += [this.value[i].code] + " ";
                    }

                    var uf = estado.split(" ");
                }
                /*var uf_selecteds = Object.keys(this.value).length;
            var estado = [];
            var i = 0;
            if(estado.lenght > 0){
                for(i = 0; i < uf_selecteds; i++){
                    if (uf_selecteds - 1 == i){
                        estado += [this.value[i].code]
                    }else{
                        estado += [this.value[i].code] + ' ';
                    }

                }
                var uf = estado.split(" ");
            }*/
                //tratamento select seguradoras
                var selected_seg = Object.keys(this.seguradoras).length;
                var seguradoras = [];
                var i = 0;
                for (i = 0; i < selected_seg; i++) {
                    if (selected_seg - 1 == i) {
                        seguradoras += [this.seguradoras[i].coluna];
                    } else {
                        seguradoras += [this.seguradoras[i].coluna] + "-";
                    }

                    var seg = seguradoras.split("-");
                }

                //Tratamento select status
                var status_selected = Object.keys(this.status).length;
                var status = [];
                var i = 0;
                for (i = 0; i < status_selected; i++) {
                    if (status_selected - 1 == i) {
                        status += [this.status[i].value];
                    } else {
                        status += [this.status[i].value] + ",";
                    }

                    var state = status.split(",");
                }

                const specificationId = this.$route.params.specificationId;

                this.axios;
                api.get("empresa/relatorio-cadastradas?", {
                    params: {
                        search: this.nomeEmpresa,
                        empresaID: this.empresa_id,
                        status: state,
                        CNPJ: this.empresa_cnpj,
                        razao_social: this.empresa_razao_social,
                        estado: uf,
                        tipo_arquivo: this.tipo_arquivo,
                        seguradoras: seg,
                        pagination: "0",
                        colunas: fields_selects,
                        tipo_busca: this.tipo_busca,
                        seguradora_data_efetivacao: this
                            .seguradoraDataEfetivacao,
                        data_inicio_efetivacao: this.dataInicioEfetivacao.replaceAll(
                            "/",
                            "-"
                        ),
                        data_fim_efetivacao: this.dataFimEfetivacao.replaceAll(
                            "/",
                            "-"
                        )
                    },
                    headers: this.headers,
                    responseType: "blob" // had to add this one here
                })
                    .then(response => {
                        this.isloading = false;
                        const content = response.headers["content-type"];
                        require("downloadjs")(
                            response.data,
                            "relatorio.xls",
                            content
                        );
                        //download(response.data, 'relatorio', content)
                    })
                    .catch(error => {
                        this.isloading = false;
                        console.log(error);
                    });
            }
        },
        clearSearch() {
            this.nomeEmpresa = "";
            this.value = "";
            this.seguradoras = "";
            this.tipo_arquivo = "";
            this.empresa_id = "";
            this.status_corretor = "";
            this.empresa_cnpj = "";
            this.campos_tabela = "";
            this.tipo_busca = "";
            this.empresa_razao_social = "";
            this.uf = "";
            this.status = "";
            this.seguradoraDataEfetivacao = null;
            this.dataInicioEfetivacao = "";
            this.dataFimEfetivacao = "";
        },
        async getCamposTabela() {
            await get("empresa/colunas-tabela").then((response) => {
                let data = response.data.result.data;
                this.options_campo_tabela = Object.values(data);
            });
        },
    }
};
</script>
<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scopped>
.cyan {
    background-color: #44a3ac;
    color: #fff;
}

.btn-outlined {
    background: transparent;
    border: 1px solid #44a3ac;
    color: #44a3ac;
    box-shadow: none;
}

.btn-outlined:hover {
    background: transparent;
}

.left {
    margin-right: 10px;
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
    .mt-md-2 {
        margin-top: 2% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/RelatorioProducao.vue